import { createSelector, createFeatureSelector } from '@ngrx/store'
import * as profileReducers from "../reducers/profiles"
import { Profile } from "../models/profile"

export const selectProfileState = createFeatureSelector<profileReducers.State>('profiles');

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = profileReducers.profileAdapter.getSelectors(selectProfileState);

export function selectAllProfiles() {
  return createSelector(
    [selectProfileState, selectAll],
    (state: profileReducers.State, profiles: Profile[]) => {
      return {
        product: state.product,
        loading: state.loading,
        error: state.error,
        profiles: profiles
    }
    }
  );
}

export function selectLoading() {
  return createSelector(
    [selectProfileState],
    (state: profileReducers.State) => {
      return state.loading;
    }
  );
}
